module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero__image",
    style: ({
      backgroundImage: 'url(' + _vm.props.backgroundimage + ')'
    })
  }), _c('div', {
    staticClass: "hero__text-box"
  }, [_c('div', {
    staticClass: "hero__title"
  }, [_vm._v(_vm._s(_vm.props.title))]), _c('div', {
    staticClass: "hero__subtext"
  }, [_vm._v(_vm._s(_vm.props.subtext))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c216de6","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/Hero/Hero.pug
// module id = 597
// module chunks = 1